export const ETAT_NON_RAPPROCHE_TYPE = 'NonRapproche';
export const ETAT_RAPPROCHE_PARTIELLEMENT_TYPE = 'RapprochePartiellement';
export const ETAT_RAPPROCHE_TYPE = 'Rapproche';

export const LIGNES_COMMANDES_ETAT_RAPPROCHEMENT = [
  { code: ETAT_NON_RAPPROCHE_TYPE, libelle: 'listeSuiviAchats.etatRapprochement.nonRapproche' },
  { code: ETAT_RAPPROCHE_PARTIELLEMENT_TYPE, libelle: 'listeSuiviAchats.etatRapprochement.rapprochePartiellement' },
  { code: ETAT_RAPPROCHE_TYPE, libelle: 'listeSuiviAchats.etatRapprochement.rapproche' },
];
